import React from "react";

import { cn } from "../../../components/common/u1/cn";
import { Modal, SessionExpired } from "../../../components/common";
import { CreditNotice } from "../../../components/common/CreditNotice";
import { PurchaseSuccess } from "../../../components/common/PurchaseSuccess";
import { Breadcrumb } from "../../../components/common/u1/Breadcrumb";
import { PageContainer } from "../../../components/common/u1/PageContainer";
import { OrderDetailsForm } from "../../../components/public/OrderWebProfile/u1/OrderDetailsForm";
import { OrderSummaryCard } from "../../../components/public/OrderWebProfile/u1/OrderSummaryCard";
import { useOrderWebProfile } from "../../../components/public/OrderWebProfile/u1/useOrderWebProfile";
import "../../../components/common/u1/tokens.css";

/* u1 Order a Web Profile — /u1/order-web-profile. */
export default function OrderWebProfile() {
  const order = useOrderWebProfile();

  return (
    <div className="u1-root min-h-screen w-full bg-[var(--bg)]">
      {order.creditNoticeOpen && (
        <Modal modalHandle={order.closeCreditNotice}>
          <p className="text-f20 font-semibold text-left">Get this business</p>
          {order.enterprises?.length > 0 && (
            <p className="text-f16 text-gray-500 text-left">
              select how you want to proceed to buy this business
            </p>
          )}
          {/* Transcribed prop for prop, including the wording that switches on
              how many credits are left. */}
          <CreditNotice
            onclick={order.closeCreditNotice}
            handlePurchased={order.submit}
            NoCredits={!order.subscription || order.creditsLeft === 0}
            title={order.creditsLeft >= 1 ? "Attention!!" : "Oopss..."}
            des={
              order.creditsLeft >= 1
                ? order.enterprises?.length > 0
                  ? `1 credit out of ${order.creditsLeft} credit(s)`
                  : `You are about to use <b> 1 credit </b> for these request. You will be left with <b> ${
                      order.creditsLeft - 1
                    } more credit of this month </b>`
                : "No credits Left"
            }
            des2={`Currently you have <b> ${order.creditsLeft} Credit </b>. Upgrade your plan to get more credit or else continue via payment method`}
            leftButton={order.creditsLeft >= 1 ? "Cancel" : "Buy Credits"}
            userInfo={order.userInfo}
            rightButton="Process"
            selectedEnterprise={order.selectedEnterprise}
            setSelectedEnterprise={order.setSelectedEnterprise}
            userEnterprise={order.enterprises}
            handleNavigation
          />
        </Modal>
      )}

      {order.successOpen && (
        <Modal modalHandle={order.finishSuccess}>
          <PurchaseSuccess
            onclick={order.finishSuccess}
            title="Business creation Successful"
            des="Enjoy the Incredible Experience of the businesses"
            button="continue"
          />
        </Modal>
      )}

      {order.sessionExpired && (
        <Modal modalHandle={order.closeSession}>
          <SessionExpired handleNavigate={order.closeSession} />
        </Modal>
      )}

      <PageContainer className="py-6">
        {/* The u1 breadcrumb, with explicit crumbs: the shared one derives its
            trail from the pathname, which here would read "u1 ›
            order-web-profile". */}
        <Breadcrumb
          items={[
            { label: "Home", to: "/" },
            { label: "Search", to: "/search" },
            { label: "Order a Web Profile" },
          ]}
        />

        <header className="mt-4 max-w-[640px]">
          <p className="m-0 text-[11.5px] font-bold uppercase tracking-[.13em] text-[var(--coral)] font-sans">
            Order a web profile
          </p>
          <h1 className="mb-0 mt-2 text-[26px] font-bold leading-[1.2] text-[var(--ink)] font-sans sm:text-[30px]">
            Request Business
          </h1>
          <p className="mb-0 mt-2.5 text-[13.5px] leading-[1.55] text-[var(--muted)] font-sans">
            Just provide us basic details of the business and we will create that
            business profile on our platform.
          </p>
        </header>

        {/* The form and the price sit side by side from `md`. Neither column is
            pinned: the price and credit cards scroll away with the form, and
            it is the navbar that stays in view instead. */}
        <div
          className={cn(
            "mt-6 grid grid-cols-1 items-start gap-6",
            "md:grid-cols-[minmax(0,1fr)_340px]"
          )}
        >
          <OrderDetailsForm order={order} />

          <OrderSummaryCard
            summary={order.summary}
            reportMode={order.reportMode}
            ordering={order.ordering}
            onPay={() => order.submit("pay")}
            onUseCredit={order.startCreditPurchase}
            /* Transcribed: offered when there is a credit on the subscription
               or an enterprise with a balance. */
            showCredit={order.creditBanner || order.enterprises?.length > 0}
            creditsLeft={order.creditsLeft}
          />
        </div>
      </PageContainer>
    </div>
  );
}
